import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { TransferWorkshopStoreDetailModel } from 'src/app/models/maintenance/transfer-workshop-store-detail.model';
import { TransferWorkshopStoreModel } from 'src/app/models/maintenance/transfer-workshop-store.model';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TransferWorkshopStoreDetailCaptureTableModel } from 'src/app/models/tables/maintenance/transfer-workshop-store-detail-capture-table.model';
import { TransferWorkshopStoreDetailService } from 'src/app/services/maintenance/transfer-workshop-store-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-transfer-workshop-store-detail',
  templateUrl: './transfer-workshop-store-detail.component.html',
  styleUrls: ['./transfer-workshop-store-detail.component.scss'],
  standalone: false
})
export class TransferWorkshopStoreDetailComponent implements OnInit {

  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;

  @Input() disabledDetail: boolean = false;
  @Input() permissionUpdatable: boolean = false;
  @Input() transferWorkshopStoreModel: TransferWorkshopStoreModel = new TransferWorkshopStoreModel();
  @Output() emitQuantityDetails = new EventEmitter<number>();
  @Output() hasQuantityInZero = new EventEmitter<boolean>();

  ascendant: boolean = true;
  ascendantArticle: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortArticle: string | null = null;
  componentTableSelection = CustomTableSelectComponent;
  dataArticle: PagedResponseModel<RentalStockModel> =
    new PagedResponseModel<RentalStockModel>();
  detailData: PagedResponseModel<TransferWorkshopStoreDetailCaptureTableModel> =
    new PagedResponseModel<TransferWorkshopStoreDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  filtersArticle: ColumnResponseModel[] = [];
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: []
  });
  inputsForTransferWorkshopStoreDetailImportModals$ = new BehaviorSubject<any>({
    transferWorkshopStoreId: 0
  });
  isFormView: boolean = false;
  limit: number = 10;
  limitArticle: number = 5;
  output$ = new Subject<any>();
  page: number = 1;
  pageArticle: number = 1;
  quantityDetails: number = 0;
  subscription: Subscription;
  tableActions: TableAction[] = [];
  transferWorkshopStoreDetail: TransferWorkshopStoreDetailModel =
    new TransferWorkshopStoreDetailModel();
  transferWorkshopStoreDetails: TransferWorkshopStoreDetailModel[] = [];

  constructor(private transferWorkshopStoreDetailService: TransferWorkshopStoreDetailService,
    private toastHandlerService: ToastHandlerService) { }

  async ngOnInit() {
    this.tableActions = this.getDefaultActions();
    await this.getColumnsForCapture();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    const disabledDetail = changes["disabledDetail"];
    const transferWorkshopStoreModel = changes["transferWorkshopStoreModel"];
    if (transferWorkshopStoreModel && !transferWorkshopStoreModel.firstChange) {
      this.clearSelectionTrigger++;
      this.getFormView(false);
      await this.getDetailsForCapture();
      this.transferWorkshopStoreDetail = new TransferWorkshopStoreDetailModel();
    }
    if (disabledDetail && !disabledDetail.firstChange) {
      this.tableActions = this.getDefaultActions();
    }
  }

  async deleteTransferWorkshopStoreDetail(selectedIds: number[]) {
    if (selectedIds.length === 0) return;

    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el detalle del traslado?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.transferWorkshopStoreDetailService.deleteSomeDetailsAsync(selectedIds));
        this.toastHandlerService.showToast('success', 'El detalle del traslado fue eliminado exitosamente.');
        this.clearSelectionTrigger++;
        await this.getUpdateListDetailByDelete();
      } catch (error) {
        console.error('Error al eliminar el detalle del traslado.', error);
      }
    }
  }

  async editTransferWorkshopStoreDetail(id: number) {
    this.transferWorkshopStoreDetail = await this.getTransferWorkshopStoreDetailById(id);
    this.getFormView(true);
  }

  async getColumnsForCapture() {
    try {
      if (this.detailHeader.length === 0) {
        const response = await firstValueFrom(this.transferWorkshopStoreDetailService.getColumnsForCapture());
        this.detailHeader = response;
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getColumnsForShopStock() {
    try {
      if (this.headerArticle.length === 0) {
        const response = await firstValueFrom(this.transferWorkshopStoreDetailService.getColumnsForShopStock());
        this.headerArticle = response;
        this.updateInputs();
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    if (this.disabledDetail) {
      return [];
    } else {
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          action: 'edit'
        }
      ];
    }
  }

  async getDetailsForCapture() {
    try {
      const transferWorkshopStoreId = this.transferWorkshopStoreModel.transferWorkshopStoreId;
      const response = await firstValueFrom(this.transferWorkshopStoreDetailService.getDetailsForCapture(this.page, this.limit,
        this.columnSort, this.ascendant, transferWorkshopStoreId));
      this.detailData = response;
      this.quantityDetails = this.detailData.totalItems;
      this.emitQuantityDetails.emit(this.quantityDetails);
      this.hasQuantityInZero.emit(this.detailData.items.some(detail => detail.quantity === 0));
    } catch (error) {
      console.error('Error al buscar los detalles del traslado.', error);
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getStocksInCostCenterWithPagination() {
    try {
      const transferWorkshopStoreId = this.transferWorkshopStoreModel.transferWorkshopStoreId;
      const response = await firstValueFrom(this.transferWorkshopStoreDetailService.getStocksInCostCenterWithPagination(transferWorkshopStoreId,
        this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle));
      this.dataArticle = response;
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getTransferWorkshopStoreDetailById(transferWorkshopStoreDetailId: number): Promise<TransferWorkshopStoreDetailModel> {
    try {
      const response = await firstValueFrom(this.transferWorkshopStoreDetailService.getByIdAsync(transferWorkshopStoreDetailId));
      this.getFormView(true);
      return response;
    } catch (error) {
      console.error('Error al obtener el detalle por id.', error);
      return new TransferWorkshopStoreDetailModel();
    }
  }

  async getTransferWorkshopStoreDetailByKeys(articleId: number, storeId: number): Promise<TransferWorkshopStoreDetailModel> {
    try {
      const transferWorkshopStoreId = this.transferWorkshopStoreModel.transferWorkshopStoreId;
      const response = await firstValueFrom(this.transferWorkshopStoreDetailService.getTransferWorkshopStoreDetailByKeys(transferWorkshopStoreId,
        articleId, storeId));
      this.getFormView(true);
      return response;
    } catch (error) {
      console.error('Error al obtener el detalle del traslado.', error);
      return new TransferWorkshopStoreDetailModel();
    }
  }

  async getUpdateListDetailByDelete() {
    this.isFormView = false;
    this.transferWorkshopStoreDetail = new TransferWorkshopStoreDetailModel();
    await this.getDetailsForCapture();
  }

  async handleSelectedItem(selectedItem: any) {
    if (selectedItem.length == 1) {
      const [{ articleId, storeId }] = selectedItem;
      const response = await this.getTransferWorkshopStoreDetailByKeys(articleId, storeId);
      if (response.transferWorkshopStoreId === 0) {
        response.storeId = storeId;
        response.articleId = articleId;
        this.transferWorkshopStoreDetail = response;
      } else {
        this.transferWorkshopStoreDetail = response;
      }
    } else {
      const newDetails = selectedItem.map((element: {
        transferStoreWorkshopId: number,
        storeId: number,
        articleId: number,
      }) => {
        const newTransferStoreWorkshopDetail = new TransferWorkshopStoreDetailModel();
        const transferWorkshopStoreId = this.transferWorkshopStoreModel.transferWorkshopStoreId;
        newTransferStoreWorkshopDetail.transferWorkshopStoreId = transferWorkshopStoreId
        newTransferStoreWorkshopDetail.articleId = element.articleId;
        newTransferStoreWorkshopDetail.storeId = element.storeId;
        return newTransferStoreWorkshopDetail;
      });
      this.transferWorkshopStoreDetails = newDetails;
    }
  }

  async onAction(event: { action: string, item?: TransferWorkshopStoreDetailCaptureTableModel, selectedItems?: number[] }) {
    switch (event.action) {
      case 'edit': {
        await this.editTransferWorkshopStoreDetail(event.item!.id);
        break;
      }
      case 'bulk-delete': {
        if (event.selectedItems) {
          await this.deleteTransferWorkshopStoreDetail(event.selectedItems);
        }
        break;
      }
    }
  }

  async openArticleSelectionModal() {
    if (!this.permissionUpdatable) {
      return this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para agregar detalles.
        Comuníquese con el administrador del sistema.`);
    }
    if (!this.transferWorkshopStoreModel.transferWorkshopStoreId) {
      return this.toastHandlerService.showToast('warning', `El traslado aún no se ha guardado.`);
    }
    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsForShopStock(),
      this.getStocksInCostCenterWithPagination()
    ]);
    this.articleSelectionModalComponent?.show();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getDetailsForCapture();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    await this.getStocksInCostCenterWithPagination();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  async reload(reload: any) {
    if (reload) {
      await this.getDetailsForCapture();
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }
}
